import type { SearchDocument, SearchResult } from "@/data/search-index"

export type HighlightPiece = string | { mark: string }

export function parseHighlight(highlight: string): HighlightPiece[] {
  if (!highlight) return []

  const parts = highlight.split(/(\{\{[^}]+\}\})/g)

  const result: HighlightPiece[] = []

  for (const part of parts) {
    if (!part) continue

    if (part.startsWith("{{") && part.endsWith("}}")) {
      const content = part.slice(2, -2)
      if (content) {
        result.push({ mark: content })
      }
    } else {
      result.push(part)
    }
  }

  return result
}

export function generateSearchHighlighter(searchResult?: SearchResult | null) {
  return (
    attr: keyof SearchDocument,
    str?: string | null,
  ): HighlightPiece[] => {
    const defaultResult = str ? [str] : []
    if (!searchResult) return defaultResult

    const highlights = searchResult.highlights?.[attr]
    if (!highlights) return defaultResult

    return parseHighlight(highlights)
  }
}
